const AppRoutes = (lang: string) => ({
  Home: lang === 'en' ? '/' : `/${lang}`,
  Instructions: lang === 'en' ? '/instructions' : `/${lang}/instructions`,
  FIBAResources: lang === 'en' ? '/fiba-resources' : `/${lang}/fiba-resources`,
  About: lang === 'en' ? '/about' : `/${lang}/about`,
  FAQ: lang === 'en' ? '/faq' : `/${lang}/faq`,
  Play: lang === 'en' ? '/play' : `/${lang}/play`,
  Clock: lang === 'en' ? '/clock' : `/${lang}/clock`,
  ReactionTraining: lang === 'en' ? '/reaction-training' : `/${lang}/reaction-training`,
  YouTube: lang === 'en' ? '/youtube' : `/${lang}/youtube`,
})

export default AppRoutes
